import {apiFetch} from '../../Config/api'

export function report(data) {
    return apiFetch('moderation/report', data)
}
export function block(data) {
    return apiFetch('moderation/block', data)
}
